import { parse } from 'clustal-js';
export default class ClustalMSA {
    constructor(text) {
        this.MSA = parse(text);
    }
    getMSA() {
        return this.MSA;
    }
    getRow(name) {
        var _a;
        return (_a = this.MSA.alns.find(aln => aln.id === name)) === null || _a === void 0 ? void 0 : _a.seq.split('');
    }
    getWidth() {
        return this.MSA.alns[0].seq.length;
    }
    getRowData() {
        return undefined;
    }
    getHeader() {
        return this.MSA.header;
    }
    getNames() {
        return this.MSA.alns.map(aln => aln.id);
    }
    getStructures() {
        return {};
    }
    get alignmentNames() {
        return [];
    }
    getTree() {
        return {
            id: 'root',
            name: 'root',
            noTree: true,
            branchset: this.getNames().map(name => ({
                id: name,
                name,
                branchset: [],
            })),
        };
    }
    get seqConsensus() {
        return this.MSA.consensus;
    }
    get secondaryStructureConsensus() {
        return undefined;
    }
    get tracks() {
        var _a;
        return ((_a = this.seqConsensus) === null || _a === void 0 ? void 0 : _a.trim())
            ? [
                {
                    id: 'seqConsensus',
                    name: 'Sequence consensus',
                    data: this.seqConsensus,
                    customColorScheme: {
                        '*': 'white',
                        ':': 'grey',
                        '.': 'darkgrey',
                        ' ': 'black',
                    },
                },
            ]
            : [];
    }
}
//# sourceMappingURL=ClustalMSA.js.map